import React from "react";
import { Slide } from "react-awesome-reveal";
import { Link } from "react-router-dom";

const CookiesPolicy: React.FC = () => {
    return (
        <div className="pattern_bg bg-white">
            <section className="page_initial_section overflow-hidden">
                <div className="container-md">
                    <div className="section_heading_area">
                        <Slide direction="down" triggerOnce>
                            <h2 className="section_heading text-center">
                                Cookies Policy
                            </h2>
                        </Slide>

                        <Slide direction="up" delay={100} triggerOnce>
                            <p className="section_desc text-center">
                                Effective date: September 19, 2024
                            </p>
                        </Slide>
                    </div>

                    <fieldset className="terms_service_container first">
                        <div className="content_number_area">1</div>
                        <div className="terms_service_content">
                            <p className="terms_service_desc">
                                We and/or other companies use cookies and other tracking technologies on our website. A cookie is an identifier (a small file of letters and numbers) that is sent to your web browser.  Cookies are widely used to make websites work, or work more efficiently, as well as to provide information to the website owner or others. Some are temporary “session” cookies that remain in the cookie file of your browser only until your browser is closed. Whereas persistent cookies stay for longer (depending on the lifetime of the specific cookie). For further information on cookies, including how to use your browser to block them and how to delete existing cookies, visit:&nbsp;
                                <Link to={'http://www.allaboutcookies.org'} className="terms_service_link">
                                    www.allaboutcookies.org.
                                </Link>&nbsp;
                                Our site’s functionality will be limited if you configure your browser to reject cookies.
                            </p>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">2</div>
                        <div className="terms_service_content">
                            <p className="terms_service_desc mb-3">
                                We ourselves may place the following types of cookies:
                            </p>

                            <div className="table-responsive">
                                <table className="table table-bordered terms_service_data_table mb-0">
                                    <thead>
                                        <tr>
                                            <th>Type of cookie</th>
                                            <th>Purpose</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Logged-in status </td>
                                            <td>Assess whether you are logged in to our site </td>
                                        </tr>
                                        <tr>
                                            <td>“Remember me” </td>
                                            <td>Remember you and speed up your login when you return to our site
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Authentication </td>
                                            <td>Identify and authenticate you to help you move easily through the
                                                site </td>
                                        </tr>
                                        <tr>
                                            <td>Preferences </td>
                                            <td>Store information about the preferences you’ve selected (e.g.,
                                                favourites, currency, wish-lists) and personalise the site </td>
                                        </tr>
                                        <tr>
                                            <td>Shopping cart </td>
                                            <td>Remember contents of your cart and related preferences </td>
                                        </tr>
                                        <tr>
                                            <td>Affiliate </td>
                                            <td>Track whether you have visited us from websites affiliated with us
                                                so we can pay affiliates and assess the effectiveness of the
                                                affiliate links </td>
                                        </tr>
                                        <tr>
                                            <td>Security </td>
                                            <td>Provide security-related features to protect our site, for example
                                                to help stop fraudulent logins </td>
                                        </tr>
                                        <tr>
                                            <td>Cookie notice </td>
                                            <td>Store your response to our cookie notice </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">3</div>
                        <div className="terms_service_content">
                            <p className="terms_service_desc">
                                Companies which provide us with a service also place cookies. Some of these cookies (e.g., from Google) may involve certain information, such as your name and contact details and/or the IP and web address of the page you’re visiting, being sent to the company concerned. Below is a summary of the kinds of cookies used together with details about who places them and where you can go to get more information and to opt out (where possible):
                            </p>

                            <div className="terms_service_list_container mt-3">
                                <ul className="terms_service_list ps-3 ps-sm-4">
                                    <li>
                                        <span className="text_bold">Analytics cookies:&nbsp;</span>These kinds of cookies recognise and count the number of website visitors as well as providing other information about the visit such as duration, route through the website and where the visitor came from. This information helps us to improve the way our website works, for example by making sure users find what they need easily. These cookies are provided by:
                                    </li>
                                    <ul className="terms_service_list ps-3 ps-sm-4">
                                        <li>
                                            Google Analytics (“GA”). More information:
                                        </li>
                                        <ul className="terms_service_sub_list ps-3 ps-sm-4">
                                            <li>
                                                Google’s&nbsp;
                                                <Link to={'https://support.google.com/analytics/answer/6004245'} className="terms_service_link" target="_blank">
                                                    overview of GA data practices and safeguarding
                                                </Link>
                                            </li>
                                            <li>
                                                how to specifically&nbsp;
                                                <Link to={'https://tools.google.com/dlpage/gaoptout/'} className="terms_service_link" target="_blank">
                                                    opt out from GA cookies
                                                </Link>
                                            </li>
                                            <li>
                                                Google’s&nbsp;
                                                <Link to={'https://policies.google.com/technologies/partner-sites'} className="terms_service_link" target="_blank">
                                                    use of its partners’ data
                                                </Link>
                                            </li>
                                        </ul>
                                    </ul>

                                    <li className="mt-4">
                                        <span className="text_bold">Analytics cookies:&nbsp;</span>These kinds of cookies are typically used to personalise ads on this or other sites based on your use of our site, to measure ad effectiveness (for example, how often you click on or view ads and whether you go on to buy something from the advertiser) and to stop you being shown the same ad repeatedly. These cookies are provided by:
                                    </li>
                                    <ul className="terms_service_list ps-3 ps-sm-4">
                                        <li>
                                            Google (including Analytics Ad Features / AdSense / Doubleclick)
                                        </li>
                                        <ul className="terms_service_sub_list ps-3 ps-sm-4">
                                            <li>
                                                how Google&nbsp;
                                                <Link to={'https://policies.google.com/technologies/ads'} className="terms_service_link" target="_blank">
                                                    uses cookies and other technologies in advertising
                                                </Link>&nbsp;
                                                including how to opt out of advertising cookies (this explains how ad personalisation works)
                                            </li>
                                            <li>
                                                Google’s&nbsp;
                                                <Link to={'https://policies.google.com/technologies/partner-sites'} className="terms_service_link" target="_blank">
                                                    use of its partners’ data
                                                </Link>
                                            </li>
                                        </ul>

                                        <li>
                                            Facebook (including “Facebook Pixel”)
                                        </li>
                                        <ul className="terms_service_sub_list ps-3 ps-sm-4">
                                            <li>
                                                Facebook’s&nbsp;
                                                <Link to={'https://www.facebook.com/policies/cookies/'} className="terms_service_link" target="_blank">
                                                    cookies policy
                                                </Link>&nbsp;
                                                (see especially under “Advertising, recommendations, insights and measurement”) including how to control Facebook’s use of cookies
                                            </li>
                                            <li>
                                                Facebook’s&nbsp;
                                                <Link to={'https://www.facebook.com/policy.php'} className="terms_service_link" target="_blank">
                                                    privacy policy
                                                </Link>
                                            </li>
                                        </ul>

                                        <li>
                                            Microsoft’s Bing
                                        </li>
                                        <ul className="terms_service_sub_list ps-3 ps-sm-4">
                                            <li>
                                                Microsoft’s&nbsp;
                                                <Link to={'https://privacy.microsoft.com/en-gb/privacystatement'} className="terms_service_link" target="_blank">
                                                    privacy policy
                                                </Link>&nbsp;
                                                including how to control Microsoft’s use of cookies
                                            </li>
                                        </ul>

                                        <p>
                                            Note that there are various places where you can go to opt out of many companies’ advertising cookies in one go including some or all of the above:
                                        </p>
                                        <ul className="terms_service_sub_list ps-3 ps-sm-4">
                                            <li>
                                                <Link to={'http://www.networkadvertising.org/choices'} className="terms_service_link" target="_blank">
                                                    www.networkadvertising.org/choices
                                                </Link>&nbsp;
                                            </li>
                                            <li>
                                                <Link to={'http://www.youronlinechoices.com/'} className="terms_service_link" target="_blank">
                                                    http://www.youronlinechoices.com/
                                                </Link>&nbsp;
                                            </li>
                                            <li>
                                                <Link to={'http://optout.aboutads.info'} className="terms_service_link" target="_blank">
                                                    http://optout.aboutads.info
                                                </Link>&nbsp;
                                            </li>
                                        </ul>
                                    </ul>

                                    <li className="mt-4">
                                        <span className="text_bold">Social media cookies:&nbsp;</span>These kinds of cookies are placed by social media companies when you use their features on another site, e.g., if you play embedded audio or video, click a Facebook “like” or send a tweet. These features may involve the relevant company using cookies to collect information relating to your visit to our website or your interaction with its services or otherwise. Here is some further information including how you can opt out where this is possible:&nbsp;
                                        <Link to={'http://www.facebook.com/help/cookies'} target="_blank" className="terms_service_link">
                                            Facebook
                                        </Link>,&nbsp;
                                        <Link to={'https://help.twitter.com/en/rules-and-policies/twitter-cookies'}
                                            target="_blank" className="terms_service_link">
                                            Twitter/X
                                        </Link>,&nbsp;
                                        <Link to={'https://policies.google.com/technologies/cookies'}
                                            target="_blank" className="terms_service_link">
                                            Google Plus
                                        </Link>,&nbsp;
                                        <Link to={'https://www.linkedin.com/legal/cookie-policy'}
                                            target="_blank" className="terms_service_link">
                                            LinkedIn
                                        </Link>,&nbsp;
                                        <Link to={'https://policy.pinterest.com/en-gb/cookies'}
                                            target="_blank" className="terms_service_link">
                                            Pinterest
                                        </Link>,&nbsp;
                                        <Link to={'https://help.instagram.com/1896641480634370?ref=ig'}
                                            target="_blank" className="terms_service_link">
                                            Instagram
                                        </Link>,&nbsp;
                                        <Link to={'https://policies.google.com/technologies/cookies'}
                                            target="_blank" className="terms_service_link">
                                            YouTube
                                        </Link>
                                    </li>

                                    <li className="mt-4">
                                        <span className="text_bold">Payment provider cookies:&nbsp;</span>Our payment provider may place cookies if you use their payment services on our service:
                                    </li>
                                    <ul className="terms_service_sub_list ps-3 ps-sm-4">
                                        <li>
                                            Paypal’s&nbsp;
                                            <Link to={'https://www.paypal.com/uk/webapps/mpp/ua/privacy-full'} className="terms_service_link" target="_blank">
                                                privacy policy
                                            </Link>
                                        </li>
                                        <li>
                                            Stripe’s&nbsp;
                                            <Link to={'https://stripe.com/gb/privacy'} className="terms_service_link" target="_blank">
                                                privacy policy
                                            </Link>
                                        </li>
                                        <li>
                                            Worldpay’s&nbsp;
                                            <Link to={'https://online.worldpay.com/terms/privacy'} className="terms_service_link" target="_blank">
                                                privacy policy
                                            </Link>
                                        </li>
                                    </ul>

                                    <li className="mt-4">
                                        <span className="text_bold">Email provider cookies:&nbsp;</span>Our email services provider may place cookies in connection with its service:
                                    </li>
                                    <ul className="terms_service_sub_list ps-3 ps-sm-4">
                                        <li>
                                            Mailchimp’s  &nbsp;
                                            <Link to={'https://mailchimp.com/en-gb/legal/cookies/'} className="terms_service_link" target="_blank">
                                                cookies policy
                                            </Link>
                                        </li>
                                    </ul>

                                    <li className="mt-4">
                                        <span className="text_bold">Third party log-in cookies:&nbsp;</span>If you log in through a third party website, that website will place its own cookies on your computer:
                                    </li>
                                    <ul className="terms_service_sub_list ps-3 ps-sm-4">
                                        <li>
                                            Facebook’s&nbsp;
                                            <Link to={'https://www.facebook.com/policy.php'} className="terms_service_link" target="_blank">
                                                privacy policy
                                            </Link>
                                        </li>
                                        <li>
                                            Google’s&nbsp;
                                            <Link to={'https://policies.google.com/privacy?hl=en-UK'} className="terms_service_link" target="_blank">
                                                privacy policy
                                            </Link>
                                        </li>
                                        <li>
                                            Apple’s&nbsp;
                                            <Link to={'https://www.apple.com/uk/legal/privacy/en-ww/'} className="terms_service_link" target="_blank">
                                                privacy policy
                                            </Link>
                                        </li>
                                    </ul>
                                </ul>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </section>
        </div>
    )
}

export default CookiesPolicy;